export const customerNames = {
  '63c94fb77376527d33b1a456': 'Superbet',
  '63c94fb77376527d33b1a537': 'Tipico dev / staging', // dev / staging
  '647761fd555c498eda820dc6': 'Tipico prod', // production
  '63eff4e9ffd137969af45804': 'Sonnenspiele',
  '640f0f80dadb9de0604da094': 'Mest',
  '650bf5968abfd064b5b44e2e': 'Finyoz dev / staging', // dev/staging
  '6567129406213fbb3757b403': 'Finyoz prod', // production
  '646227d3c2b1798cd038302b': 'Wealthguardian',
  '644b9d71e1274bd54df775a6': 'Shangri-la-singapore',
  '64b7a9be8d9679c14f555329': 'Shangri-la-singapore',
  '64916c18b3811dfa5c2cc1d2': 'Tink',
  '647efca334a855cf37cf58c3': 'Paylado dev / staging', // dev/staging
  '64d108c8bbb08049198a7eb3': 'Paylado prod', // prod
  '64a2c9c785219dfcb177d2d2': 'Sira',
  '64c919b1373499249f9fe9c2': 'Atv demo dev / staging', // dev/staging
  '65783a7806213fbb3758c621': 'Atv demo prod', // prod
  '64d1eaa7373499249f9fe9ff': 'Finductive',
  '6513e8ade69ade8ed715a2f6': 'Finductive',
  '65364b7e9eb0f5a2a3982f67': 'Finductive',
  '649025e334a855cf37cf58c7': 'Sonio demo',
  '6458d9376d93b46181616cad': 'Bitmambo',
  '6461e14755438257d44f0abd': 'Bitmambo',
  '6511858ba8a946cc4a9e1d27': 'Staple demo',
  '653903dc9eb0f5a2a3982f6a': 'Regula demo',
  '65cb2fcf8db0af6615cc61eb': 'Tipico 2',
  '65c34f41e446fc3e87772606': 'Rootz',
  '6527bf168abfd064b5b44e3b': 'Tink',
  '65f42c272156d096dbe51ca5': 'Intertops',
  '660e5bd95e418f8f800fbaa8': 'Daznbet',
  '6682626c20b3b7d3d3a64666': 'Megapixel',
  // Slotmagie
  '697c84208ecd9f08428cd7b8': 'Flow 1: Schufa + POI + POA + AML',
  '6992d7db1dbe22f78d20c8d0': 'Flow 2: POI + POA + AML',
  '69a56dfe457b8497fccfa542': 'Flow 3: Schufa + POA',
  '69a7f7424bea477685aac59d': 'Flow 4: Schufa G',
  '69ca32a01a8e5200217aee9d': 'Flow 5: Schufa',
  '683d365e8a4c1bafc6f30f78': 'Tipico AUT POI',
  '683d36a68a4c1bafc6f30f79': 'Tipico AUT POI POA',

  // Tipico Lower Austria (new)
  '68e7556d2b314a2812ced28a': 'POI',
  '68e755752b314a2812ced28b': 'POI + POA',
  '696f4429f8a633b698fda52e': 'RG',
  '696f4470f8a633b698fda530': 'AML',
  '699d7d5d1dbe22f78d20c8eb': 'POA Only',
  // end

  // Pluso
  '69eb6e3b52b7246cf4c2de63': 'Pluso DEMO',
  // end
};

export const customerFlowNames = {
  '65ddc749649a287d57470f36': 'Intertops',
  '65d48d158db0af6615cc61f2': 'Smart Checkin',
  '65d48ce38db0af6615cc61f1': 'Drei',
  '65d36f128db0af6615cc61f0': 'Betano',
  '65cf6d258db0af6615cc61ee': 'Spinz',
  '6555deb29eb0f5a2a3982f9b': 'Data Matching',
  '65b9144be446fc3e87772601': 'DaznBet',
  '655f3b7878500066d5ce3c91': 'Rootz',
  '654cbaef9eb0f5a2a3982f92': 'Sunmaker',
  '64ff1481577da6fd13f049d4': 'Betshop',
  '64f701c26f1a5ed15a49917c': 'Albsig',
  '65dc579b649a287d57470f2e': 'Tipico Games',
  '6526590a8abfd064b5b44e39': 'Finductive v4',
  '65c34720e446fc3e87772605': 'Test Ekata V4',
  '65ddc5bc649a287d57470f35': 'Mest',
  '65703fba78500066d5ce67b2': 'New Terminal',
  '6411c064a47f80dc7e9bd748': 'Old Terminal',
  '6578344478500066d5ce67b5': 'Mest V2',
  '65a6a308e446fc3e877725f4': 'Sonnenspiele v4',
  '65c353ade446fc3e87772608': 'Rootz POI v4',
  '654670a19eb0f5a2a3982f85': 'Finyoz POI v4',
  '6527bedc8abfd064b5b44e3a': 'Tink v4',
  '64916bca34a855cf37cf58c9': 'Tink v3',
  '662b6ced5e418f8f800fbad0': 'Daznbet 1',
  '662b76a95e418f8f800fbad5': 'Daznbet 2',
  '662b76be5e418f8f800fbad7': 'Daznbet 3',
  '662b76d15e418f8f800fbad9': 'Daznbet 4',
  '662b76f05e418f8f800fbadb': 'Daznbet 5',
  '6679889b20b3b7d3d3a6465f': 'Betfair',
  '65f42da72156d096dbe51ca6': 'Intertops v4',
  '67ee5bc8af0e3d96cc760264': 'Mest POA',
  '6697891ea33fbc4006e57865': 'Mest Terminal v4',

  // tipico sports
  '65e877d12156d096dbe51ca0': 'Limits',
  '686bca6cf9073ffc24b2ff8c': 'Limits Small',
  '65e877632156d096dbe51c9e': 'RG',
  '65e877c02156d096dbe51c9f': 'AML',

  '667bd06920b3b7d3d3a64660': 'Tipico Sports Test upload Elie (RG)',
  '65ca169f8db0af6615cc61e7': 'Tipico Sports Tink Demo',
  '667bd07020b3b7d3d3a64661': 'Tipico Sports Test upload Elie (AML)',
  '667bd07920b3b7d3d3a64662': 'Tipico Sports Test upload Elie (V)',
  '66a0ddf810e4b3d220f82de0':
    'Tipico Sports Tink Alternative flow with only upload (hide tink)',
  '67112cbb5507b606aa9cdbd5': 'Tipico Sports Tink (AS)',
  '673c660560d53e97ce601d9d': 'Tipico Sports Tink (AS)',

  '6836f338b726f491635dca57': 'Tipico AUT POI POA',
  '6836f0f8b726f491635dca56': 'Tipico AUT POI',
  '67da9f00efd804a98275abd3': 'Tipico Face Auth',
  // Tipico Austria (prod)
  '683d365e8a4c1bafc6f30f78': 'Tipico AUT POI',
  '683d36a68a4c1bafc6f30f79': 'Tipico AUT POI POA',
  '679a17c1ceb8fbe492c5de43': 'Spinz POA',
  '686cf19b2c79ced280050a7a': 'STS POI',
  '68188c7a78dc6e99267417b0': 'Rootz POI POA DE',
  '68188db678dc6e99267417b2': 'Rootz POA DE',
  '68188d3c78dc6e99267417b1': 'Rootz POI or Bank Ident DE',
  '686e5cd61bc0e445744510cd': 'Rootz Sekura Canada',

  '684fcdc2ece13d1fcf17a3ba': 'ComeOn',
  '65ddb396649a287d57470f32': 'Wildz',
  '679a17beceb8fbe492c5de42': 'Wildz POA',
  '65ddb3ae649a287d57470f34': 'Caxino',
  '679a17a5ceb8fbe492c5de40': 'Caxino POA',
  '679a17b8ceb8fbe492c5de41': 'Wheelz POA',
  '65ddb3a6649a287d57470f33': 'Wheelz',
  '667ebfca20b3b7d3d3a64665': 'Megapixel IDV',
  '6720cf7b0fde69a791f078c2': 'Megapixel IDV POA',
  '698c87261dbe22f78d20c8bb': 'Betclic ID Upload',
  '698c886c1dbe22f78d20c8bc': 'Betclic IDV',
  // Slotmagie
  '697c84208ecd9f08428cd7b8': 'Schufa + POI + POA + AML',
  '6992d7db1dbe22f78d20c8d0': 'POI + POA + AML',
  '69a56dfe457b8497fccfa542': 'Schufa + POA',
  '69a7f7424bea477685aac59d': 'Schufa G',
  '69ca32a01a8e5200217aee9d': 'Schufa',

  // Tipico IDV Sports Germany
  '67d1537a0816c4f8be3981f2': 'POI', // dev
  '68877911895b0db560b1268c': 'POI', // live
  '69aea238c9aa438c178a58f6': 'POA only', // dev
  '69b12ad8a22ba550370c7152': 'POA only', // live
  // end

  // Tipico IDV Games Germany
  '69aea26bc9aa438c178a58f8': 'POA only', // dev
  '69b12b14a22ba550370c7154': 'POA only', // live
  // end

  // Tipico affordability sports germany
  '686bc6b7f9073ffc24b2ff88': 'Limits Small',
  '673c544357cef7322b565964': 'Limits',
  '673c53f557cef7322b565963': 'AML',
  '673c53b357cef7322b565962': 'RG',
  // end

  //Tipico TKAL
  '696de70cf8a633b698fda511': 'RG',
  '696de773f8a633b698fda512': 'AML',
  '696de7e6f8a633b698fda513': 'Limits Small',
  '696de81bf8a633b698fda514': 'Limits',

  // Tipico Lower Austria (new)
  '68e7556d2b314a2812ced28a': 'POI',
  '68e7565b2b314a2812ced28e': 'POI', // live
  '68e755752b314a2812ced28b': 'POI + POA',
  '68e7565f2b314a2812ced28f': 'POI + POA', // live
  '696f4429f8a633b698fda52e': 'RG', // dev
  '696f44b3f8a633b698fda534': 'RG', // live
  '696f4470f8a633b698fda530': 'AML', // dev
  '696f44ddf8a633b698fda536': 'AML', // live
  '699d7d5d1dbe22f78d20c8eb': 'POA Only',
  '699d7e3a1dbe22f78d20c8ec': 'POA Only', // live
  // end

  // pluso
  '69eb6e3b52b7246cf4c2de63': 'Pluso DEMO',

  // novibet id upload
  '6a0c2053c41dd84fd7aeb66e': 'Novibet - IDV',

  // pluso - id upload
  '6a047f2072f2dac10e15594d': 'Pluso - ID upload',

  // Laxton Demo
  '6a26ce634c8be0d5099a7bdb': 'Laxton DEMO',
};
